import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateField from "../../../components/Fields/DateField";
import NumberField from "../../../components/Fields/NumberField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import PriceTrancheModel from "../../../models/PriceTrancheModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

interface Props extends PopupProps {
    priceTrancheTypeId: number
}

const AddPriceTranchePopup: React.FC<Props> = ({ show, onHide, priceTrancheTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<PriceTrancheModel>();

    useEffect(() => {
        setFormData({
            priceTrancheTypeId: priceTrancheTypeId,
            beginDate: new FormatUtils().formatDateForStorage(new Date()),
            concurrencyId: ''
        } as PriceTrancheModel);
    }, [])

    function submit() {
        if (formData) {
            DataService
                .create<PriceTrancheModel>(`api/v1/PriceTranches`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'quantityFrom', label: 'Volume from', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'quantityTo', label: 'Volume to', labelSize: 2  },
            { name: 'beginDate', label: 'From', labelSize: 2, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Until', labelSize: 2 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add volume'} >
            <Popup.Body>
                <NumberField {...getFieldProps('quantityFrom')}  />
                <NumberField {...getFieldProps('quantityTo')} />
                <DateField {...getFieldProps('beginDate')} />
                <DateField {...getFieldProps('endDate')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddPriceTranchePopup;